import { render, staticRenderFns } from "./AdminRequirments.vue?vue&type=template&id=9fe76ebe"
import script from "./AdminRequirments.vue?vue&type=script&lang=js"
export * from "./AdminRequirments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports